import styles from '@redturtle/qubicaamf-theme/components/Header/styles.module.css';
import LocalWebSiteMenu from '@redturtle/qubicaamf-theme/components/Header/LocalWebSiteMenu';
import CartSVG from '@redturtle/qubicaamf-theme/components/Icons/CartSVG';

export default function HeaderSlim() {
  return (
    <div className={styles.headerSlim}>
      <ul>
        <li>
          <a className={styles.careers} href={`https://careers.qubicaamf.com/`}>
            Careers
          </a>
        </li>
        <li>
          <LocalWebSiteMenu />
        </li>
        <li>
          {/* @ts-ignore */}
          <a title="QubicaAMF eShop" href="https://eshop.qubicaamf.com/">
            <CartSVG size="M" />
          </a>
        </li>
      </ul>
    </div>
  );
}
